import { ResourceSourceIcon } from './ResourceSourceIcon';

interface ResourceRowContentProps {
  /** The URI the row's icon is read from. */
  uri: string;
  name: string;
  /** A second line under the name, or `null` for none. */
  note: string | null;
}

/** What a row of a resource list shows (a card's menus, the resource page): icon, name and note. */
export function ResourceRowContent({ uri, name, note }: ResourceRowContentProps) {
  return (
    <>
      <ResourceSourceIcon uri={uri} />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-foreground">{name}</span>
        {/* The space keeps name and note apart in the row's accessible name; a flex column does not render it. */}
        {note && (
          <>
            {' '}
            <span className="truncate text-xs text-muted-foreground">{note}</span>
          </>
        )}
      </span>
    </>
  );
}
